import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import type { ButtonProps } from "./Button";

export const BackButton = ({ className, ...rest }: ButtonProps) => (
  <IconButton
    name="20-back-to-community"
    iconSize={20}
    buttonSize={28}
    ariaLabel={t("back")}
    className={classNames("h-8 w-8", className)}
    data-testid="builder-ui-back-button"
    {...rest}
  />
);
